/*
 * Copyright (c) 2026. Bolmate B.V.
 */
import React from 'react';

import percent from '@iconify/icons-feather/percent';

import {useTranslation} from 'react-i18next';

import BolmateSetupCard from './bolmateSetupCard';

interface Props {
    completed?: boolean;
    onClick?: () => void;
    onCheckClick?: () => void;
    className?: string;
}

export default function BolmateVatSetupCard(props: Props) {
    const {completed, onClick, onCheckClick, className} = props;
    const {t} = useTranslation();

    return (
        <BolmateSetupCard
            className={className}
            title={t('controls.setupCard.vatSetup.title', 'Btw % producten')}
            subtitle={t('controls.setupCard.vatSetup.subtitle', 'Wijk optioneel af van 21%')}
            icon={percent}
            completed={completed}
            onClick={onClick}
            onCheckClick={onCheckClick}
        />
    );
}
